import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import useFormHook from '@shared/hooks/useFormHook';
import { personService } from '@shared/services/personService';
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import CustomDatePicker from '@shared/components/CustomDatePicker';


export default function PensionHistoryForm({ onClose, onConfirm, editData, formProps }) {
    const { t } = useTranslation();
    const { modalRef } = useFormHook({}, onClose);
    const { register, handleSubmit, setValue, watch, errors } = formProps;
    const { id } = useParams();
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();



    useEffect(() => {
        if (editData) {
            setValue('fromDate', editData.fromDate);
            setValue('toDate', editData.toDate);
            setValue('amount', editData.amount);
        }
    }, [editData, setValue]);

    useEffect(() => {
        const fetchFiles = async () => {
            try {
                setLoading(true);
                const response = await personService.getSystemDocuments(id);
                setFiles(response);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching files:', error);
                setLoading(false);
            }
        };

        fetchFiles();
    }, [id]);

    const submitForm = async (data) => {
        try {
            const formData = {
                personId: parseInt(id),
                fromDate: data.fromDate,
                toDate: data.toDate,
                amount: data.amount
            };

            if (onConfirm) {
                await onConfirm(formData);
            }
        } catch (error) {
            console.error('Error saving pension history:', error);
        }
    };

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog modal-confirm" ref={modalRef}>
                <div className="modal-content">
                    <button type="button" className="close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <div className="modal-body">
                        <h4 className="modal-title">
                            {editData ? t('common.edit') : t('common.add')} {t('Compensations as per labor contracts.pensionHistory.title')}
                        </h4>
                        <form id="pensionHistoryForm" className="region-form" onSubmit={handleSubmit(submitForm)}>
                            <div className="form-group">
                                <span className="span-bold">
                                    {t('Compensations as per labor contracts.pensionHistory.form.inEffectFrom')} <span className="required">*</span>
                                </span>
                                <CustomDatePicker
                                    name="fromDate"
                                    errors={errors}
                                    value={watch('fromDate')}
                                    onChange={(date) => setValue('fromDate', date, { shouldValidate: true })}
                                    placeholderText={t('common.dateFormat')}
                                    maxDate={new Date()}
                                />
                            </div>

                            <div className="form-group">
                                <span className="span-bold">
                                    {t('persons.workingCapacity.documentAttached')}
                                </span>
                                {loading ? (
                                    <div>{t('persons.workingCapacity.loadingDocuments')}</div>
                                ) : (
                                            <select
                                                className={`form-control 'is-invalid' : ''}`}
                                                {...register('docId')}
                                            >
                                                <option value="">{t('persons.workingCapacity.chooseDocument')}</option>
                                                {files.map(file => (
                                                    <option key={file.id} value={file.id}>
                                                        {file.empdoctype}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                       
                                        <button type="button" className="btn btn-info" onClick={() => navigate(`/system-documents/${id}`)}>
                                            {t('common.viewDocuments')}
                                        </button>
                                    </div>

                            <div className="form-group">
                                <span className="span-bold">
                                    {t('Compensations as per labor contracts.pensionHistory.form.sum')} <span className="required">*</span>
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    {...register('amount', { required: true })}
                                />
                            </div>
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="submit" form="pensionHistoryForm" className="btn btn-primary">
                            {t('common.save')}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
